import { NgModule } from '@angular/core';
import { DatepickerComponent } from './datepicker.component';
import { TranslateModule } from '@ngx-translate/core';
import { DateModule } from '../../date.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [TranslateModule.forChild(), DateModule, MatTooltipModule, SvgIconModule],
  declarations: [DatepickerComponent],
  exports: [DatepickerComponent],
})
export class DatepickerModule {}
